import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { SocialAuthService, SocialUser } from "@abacritt/angularx-social-login";
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAuthState } from '../../store/selectors/auth.selectors';
import * as AuthActions from '../../store/actions/auth.actions';
import { CoreService } from '@app/modules/core/services/core.service';
import { FunctionsService } from '@app/modules/core/services/functions.service';
import { StateStatuses } from '@app/store/enums/state-statuses.enum';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { LoginTypes } from 'shared-library';

declare const google: any;

@Component({
    selector: 'app-auth-google',
    templateUrl: './auth-google.component.html',
    styleUrls: ['./auth-google.component.scss'],
})
export class AuthGoogleComponent implements OnInit, OnDestroy, AfterViewInit {

    private user: SocialUser;
    private subscriptions: Subscription[] = []
    authState$ = this.store.select(selectAuthState);

    private sign_in_init = false
    private sign_in_init_cc: any

    state_statuses = {
        FAILED: StateStatuses.FAILED,
        PENDING: StateStatuses.PENDING,
        SUCCESS: StateStatuses.SUCCESS,
        PROCESSING: StateStatuses.PROCESSING,
    }

    auth_types = {
        EMAIL: LoginTypes.EMAIL,
        GOOGLE: LoginTypes.GOOGLE,
        // FACEBOOK: LoginTypes.FACEBOOK,
    }

    activating_ots_qr: string
    activation_code_ots_qr: string

    constructor(
        private store: Store,
        private cookieService: CookieService,
        private functionService: FunctionsService,
        private readonly coreService: CoreService,
        private socialAuthService: SocialAuthService
    ) {
        this.subscriptions.push(this.authState$.subscribe(ls => {
            this.activating_ots_qr = ls.data.activating_ots_qr
            this.activation_code_ots_qr = ls.data.activation_code_ots_qr
        }))
    }

    ngOnInit(): void {
        this.subscriptions.push(this.socialAuthService.authState.subscribe(async user => {
            this.user = user;
            this.functionService.logToConsole(user)
            if (this.user) {
                // Send to be
                this.store.dispatch(AuthActions.login({
                    data: {
                        otp: "",
                        email: "",
                        password: "",
                        id_token: this.user.idToken,
                        login_type: LoginTypes.GOOGLE,
                        activating_ots_qr: this.activating_ots_qr,
                        activation_code_ots_qr: this.activation_code_ots_qr,
                        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                        recaptcha_token: await this.coreService.getRecaptchaToken(),
                        referral_id: this.cookieService.get(environment.referral_cookie_key),
                    }
                }))
            }
        }))
    }

    ngAfterViewInit() {
        const initButton = () => {
            if (typeof google === typeof undefined || !google?.accounts?.id) {
                this.sign_in_init = false
                return
            }
            this.sign_in_init = true
            clearInterval(this.sign_in_init_cc)
            google.accounts.id.renderButton(
                document.getElementById("asl-google-signin-button"),
                {
                    size: "large",
                    shape: "circle",
                    type: "standard",
                    theme: "outline",
                    context: "signup",
                    text: "continue_with",
                }  // customization attributes
            );
        }

        initButton()
        if (!this.sign_in_init) {
            clearInterval(this.sign_in_init_cc)
            this.sign_in_init_cc = setInterval(() => initButton(), 1000)
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.map(sub => sub.unsubscribe())
    }

}
